import { IAdminsettings, IAdminSettingsResponse, IAdminSaveResponse } from './interfaces';
import { authorizedFetch } from 'abu-common-components';
import { serviceConstants } from './utils/constant';

export const readBookingAdminToolSettings = async (): Promise<IAdminSettingsResponse | string> => {
  const response = await authorizedFetch(process.env.REACT_APP_ADMIN_READ_SETTINGS as string, {
    method: 'GET',
    skipAuth: true
  });
  if (!response.ok || response.data === null) {
    return 'Failed to fetch';
  }
  return response.data as IAdminSettingsResponse;
};

export const saveBookingAdminToolSettings = async (adminSettings: IAdminsettings): Promise<IAdminSaveResponse | string> => {
  const response = await authorizedFetch(process.env.REACT_APP_ADMIN_SAVE_SETTINGS as string, {
    method: 'POST',
    body: JSON.stringify(adminSettings),
    tokenKey: serviceConstants.OKTA_TOKEN_KEY
  });
  if (!response.ok || response.data === null) {
    return 'Failed to fetch';
  }
  return response.data as IAdminSaveResponse;
};
